'use client'

import { AccessoriesPage } from 'pageCores/Accessories/components'

import { useGetMemberDataFromAppInjection } from 'components/_hooks/useGetMemberDataFromAppInjection'
import { isOlderThanXDays } from 'components/_utils/Date.utils'
import { PodUpsell } from 'components/PodUpsell'
import { useRouter } from 'next/navigation'
import { FC, useCallback, useEffect } from 'react'
import { useStore } from 'stores/StoreProvider'

const AccessoriesContent: FC = () => {
	const { subscriptionInformation, limitReached } = useGetMemberDataFromAppInjection()
	const setSubscriptionInformation = useStore((state) => state.shop.setSubscriptionInformation)

	const router = useRouter()

	const updateSubscriptionInfo = useCallback(() => {
		if (subscriptionInformation) {
			setSubscriptionInformation(subscriptionInformation)
		}
	}, [subscriptionInformation, setSubscriptionInformation])

	const ensureUserIsValidMember = useCallback(() => {
		if (!subscriptionInformation) {
			if (limitReached) router.push('/login')
			return
		}

		if (!subscriptionInformation?.userCreatedDate || !isOlderThanXDays(subscriptionInformation.userCreatedDate, 30)) {
			router.push('/login')
		}
	}, [subscriptionInformation, limitReached, router])

	useEffect(() => {
		updateSubscriptionInfo()
		// ensureUserIsValidMember()
	}, [updateSubscriptionInfo, ensureUserIsValidMember])

	return (
		<>
			<h1 className={'vh'}>Everything you need to optimize your sleep fitness</h1>
			<AccessoriesPage />
			<PodUpsell />
		</>
	)
}

export { AccessoriesContent }
